import {motion} from 'framer-motion';


export const HistoryItem = ({data}) => {

    const animation = {
        hidden: { opacity: 0, y: -100 },
        show: {
          opacity: 1,
          y: 0,
          transition: {
            staggerChildren: 0.7,
            duration: 0.5,
            type: 'spring',
            damping: 10,
            stiffness: 100 
          }
        }
      };

    const result = data.map((item) =>  (
        <div key={item.id} className="row mt-2">
            <div className="accordion accordion-flush" id="accordionFlushExample">
                <motion.div className="accordion-item"
                    variants={animation}
                    initial="hidden"
                    animate="show"
                >
                    <h2 className="accordion-header">
                    <button className="accordion-button collapsed custom" type="button" data-bs-toggle="collapse" data-bs-target={`#order-${item.id}`}>
                        <span>Замовлення: №{item.id}</span><span className="ms-auto text-end"></span>
                    </button>
                    </h2>
                    <div id={`order-${item.id}`} className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Товар</th>
                                        <th scope="col">Кількість</th>
                                        <th scope="col">Cума</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.orders.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.name}</td>
                                            <td>{item.qtt}</td>
                                            <td className='text-end'>{item.amount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr style={{borderBottom: 'none', borderColor: 'white'}}>
                                        <td colSpan={2}>Загальна сума</td>
                                        <td className='text-end'>{item.amount}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    ))

    return result
}